import React from "react";
import styled, { css } from "styled-components";
import PromotingTitle from "./PromotingTitle";
import PromotingContent from "./PromotingContent";
import AOS from "aos";

interface PromotingInterface {
  Home: boolean;
}

type Props = {
  Home: boolean;
};

const Promoting: React.FC<PromotingInterface> = ({ Home }) => {
  React.useEffect(() => {
    AOS.init();
  }, []);
  return (
    <PromotingWrapper data-aos="fade-up" Home={Home}>
      <PromotingTitle
        boldText={
          Home === true
            ? "Promoting your business and services with Propel: "
            : "Electram constituto eam id. Eum illud option te, ea vim tractatos. "
        }
        otherText={
          Home === true
            ? "A responsive, multi-page business template with everything you need propel your business."
            : "Mazim putant ex mea, et nullam suscipit eam, qui accommodare vituperatoribus at."
        }
      />
      <PromotingContent Home={Home} />
    </PromotingWrapper>
  );
};

export default Promoting;

const PromotingWrapper = styled.div<Props>`
  width: 100vw;
  overflow-x: hidden;
  height: auto;
  padding-bottom: 10vh;
`;
